import React, { useState } from 'react'
import { Modal, ModalBody, Col, Input, Button } from 'reactstrap'
import styled from 'styled-components'
import BlockUi from 'react-block-ui'
import { Loader } from 'react-loaders'
import { PaymentInputsWrapper, usePaymentInputs } from 'react-payment-inputs'
import images from 'react-payment-inputs/images'
import { toast } from 'react-toastify'
import api from '../../services/api'

const StyledModalBody = styled(ModalBody)`
  @media (max-width: 768px) {
    padding: 35px 5px;
  }
`

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

function PaymentDataModal(props) {
  const [loading, setLoading] = useState(false)
  const [cardNumber, setCardNumber] = useState('')
  const [holder, setHolder] = useState('')
  const [expirationDate, setExpirationDate] = useState('')
  const [cvc, setCVC] = useState('')

  const handleSubmit = event => {
    event.preventDefault()

    if(cardNumber === '' || expirationDate === '' || cvc === '') {
      toast.error('Preencha os dados do Cartão de crédito')
      return false
    }

    if(holder === '') {
      toast.error('Preencha o nome do titular')
      return false
    }

    const data = {
      CardNumber: cardNumber.replace(/\s/g, ''),
      Holder: holder,
      ExpirationDate: formatExpirationDate(expirationDate),
      SecurityCode: cvc, 
      Brand: meta.cardType.type === "mastercard" ? "Master" : meta.cardType.type
    }

    api.put(`/update-recurrence/${props.payment.recurrent.recurrentPaymentId}`, data).then(response => {
      toast.success(response.message)
      props.handleModal()
      setCardNumber('')
      setHolder('')
      setExpirationDate('')
      setCVC('')
    }).catch(error => {
      console.log(error)
    })
  }

  const formatExpirationDate = expirationDate => {
    let withOutSpaces = expirationDate.replace(/\s/g, '')
    const left = withOutSpaces.substr(0, 2)
    const right = withOutSpaces.substr(3, 4)
    const formatted = `${left}/20${right}`

    return formatted
  }

  const ERROR_MESSAGES = {
    emptyCardNumber: 'O número do cartão não pode estar vazio.',
    invalidCardNumber: 'O número do cartão é inválido.',
    emptyExpiryDate: 'A data de expiração não pode estar vazia.',
    monthOutOfRange: 'O mês de expiração deve estar entre 01 e 12.',
    yearOutOfRange: 'O ano de expiração não pode estar no passado.',
    dateOutOfRange: 'A data de expiração não pode estar no passado.',
    invalidExpiryDate: 'A data de expiração é inválida.',
    emptyCVC: 'O código de segurança não pode estar vazio.',
    invalidCVC: 'O código de segurança é inválido.'
  }

  const {
    meta,
    wrapperProps,
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps
  } = usePaymentInputs({ errorMessages: ERROR_MESSAGES });

  return (
    <>
      <Modal isOpen={props.visible} toggle={props.handleModal} size="lg" centered>
        <StyledModalBody>
          <BlockUi tag="div" blocking={loading} loader={<Loader active type="line-scale-party" color="#296ba9" />} >
            <FormContainer>
              <Col xs={12} md={7} style={{ textAlign: "center" }}>
                  <h3 style={{ marginBottom: "1em" }}>Editar dados de pagamento</h3>

                  <PaymentInputsWrapper {...wrapperProps} style={{ width: '100%', marginBottom: '1em' }}>
                    <svg {...getCardImageProps({ images })} />
                    <input {...getCardNumberProps({ onChange: (event) => setCardNumber(event.target.value) })} placeholder="Nº do Cartão de Crédito" value={cardNumber} />
                    <input {...getExpiryDateProps({ onChange: (event) => setExpirationDate(event.target.value) })} placeholder="MM/AA" value={expirationDate} />
                    <input {...getCVCProps({ onChange: (event) => setCVC(event.target.value) })} value={cvc} />
                  </PaymentInputsWrapper>

                  <Input
                    placeholder="Titular"
                    value={holder}
                    onChange={event => setHolder(event.target.value)}
                    style={{ marginBottom: "1em" }}
                  />

                  <Button onClick={() => props.handleModal()}>
                    Voltar
                  </Button>

                  <Button
                    style={{ backgroundColor: "rgba(41,107,169,1)", border: 'none', margin: "1em" }}
                    onClick={(event) => handleSubmit(event)}
                  >
                    Atualizar
                  </Button>
              </Col>
            </FormContainer>
          </BlockUi>
        </StyledModalBody>
      </Modal>
    </>
  );
}



export default PaymentDataModal;